import { styled } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza/text'
import { ReactNode } from 'react'

type MessageMetadataProps = {
    sender: ReactNode
    recipient: ReactNode
    subject: ReactNode
    copy?: Partial<MessageMetadataCopy>
}

export type MessageMetadataCopy = {
    sender: string
    recipient: string
    subject: string
}

const DEFAULT_MESSAGE_METADATA_COPY: MessageMetadataCopy = {
    sender: 'Von',
    recipient: 'An',
    subject: 'Betreff',
}

export function MessageMetadata({ sender, recipient, subject, copy }: MessageMetadataProps) {
    const resolvedCopy = { ...DEFAULT_MESSAGE_METADATA_COPY, ...copy }

    return (
        <MetadataGrid>
            <Typography variant="textS" color={tokens.ColorTextDefault}>
                {resolvedCopy.sender}
            </Typography>
            <Typography variant="textS" color={tokens.ColorTextBold}>
                {sender}
            </Typography>

            <Typography variant="textS" color={tokens.ColorTextDefault}>
                {resolvedCopy.recipient}
            </Typography>
            <Typography variant="textS" color={tokens.ColorTextBold}>
                {recipient}
            </Typography>

            <Typography variant="textS" color={tokens.ColorTextDefault}>
                {resolvedCopy.subject}
            </Typography>
            <Typography variant="textS" color={tokens.ColorTextBold}>
                {subject}
            </Typography>
        </MetadataGrid>
    )
}

const MetadataGrid = styled('div')(() => ({
    display: 'grid',
    gridTemplateColumns: 'fit-content(100%) minmax(0, 1fr)',
    columnGap: tokens.SizingSpacing150,
    rowGap: tokens.SizingSpacing050,
}))
